import {
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
} from '@chakra-ui/react';
import { StripeBillingAccountListingResponse } from '@zap-onboard/api-client';
import { StripeBillingAccountUpdatePaymentMethodForm } from './stripe/StripeBillingAccountUpdatePaymentMethodForm';

export const PaymentMethodModal = (args: {
  billingAccount: StripeBillingAccountListingResponse;
  disclosure: ReturnType<typeof useDisclosure>;
}) => {
  const { isOpen, onClose } = args.disclosure;

  return (
    <Modal closeOnOverlayClick isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader fontSize="md" />
        <ModalBody fontSize="sm" pb={6}>
          <StripeBillingAccountUpdatePaymentMethodForm
            billingAccountId={args.billingAccount.billingAccountId}
            onSaved={onClose}
            onCancel={onClose}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
